<template>
  <div class="profile-page">

    <!-- Page header -->
    <div class="page-header">
      <button class="back-btn" onclick="window.history.back()"><i class="ft-arrow-left"></i></button>
      <div class="header-info">
        <span class="page-title">My Profile</span>
        <span class="page-subtitle">Manage your account details</span>
      </div>
    </div>

    <!-- Avatar hero -->
    <div class="avatar-hero">
      <div class="avatar-wrap" @click="$refs.file.click()">
        <img :src="pic" class="avatar-img" alt="Profile picture" />
        <div class="avatar-overlay">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
            <circle cx="12" cy="13" r="4"/>
          </svg>
        </div>
        <input type="file" ref="file" class="file-input" v-on:change="updatePic()" accept="image/*" />
      </div>
      <p class="avatar-name">{{ first_name }} {{ last_name }}</p>
      <p class="avatar-email">{{ email }}</p>
    </div>

    <div class="section-pad">

      <!-- ── Update Profile ── -->
      <div class="form-card">
        <div class="form-card-header">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          Profile Information
        </div>

        <form id="profile-form" v-on:submit.prevent="updateProfile">
          <div class="fields-wrap">

            <div class="field-group">
              <label class="field-label">First Name</label>
              <div class="input-wrap">
                <i class="ft-user input-icon"></i>
                <input type="text" class="field-input" v-model="first_name" placeholder="First name" required />
              </div>
            </div>

            <div class="field-group">
              <label class="field-label">Last Name</label>
              <div class="input-wrap">
                <i class="ft-user input-icon"></i>
                <input type="text" class="field-input" v-model="last_name" placeholder="Last name" required />
              </div>
            </div>

            <div class="field-group">
              <label class="field-label">Email Address</label>
              <div class="input-wrap">
                <i class="ft-mail input-icon"></i>
                <input type="email" class="field-input" v-model="email" placeholder="Email address" required />
              </div>
            </div>

            <div class="field-group">
              <label class="field-label">Cellphone</label>
              <div class="input-wrap">
                <i class="ft-phone input-icon"></i>
                <input type="text" class="field-input" v-model="cellphone" placeholder="Cellphone number" />
              </div>
            </div>

          </div>

          <!-- Messages -->
          <div class="msg msg--error" v-if="errorMsg">
            <i class="ft-alert-circle"></i> {{ errorMsg }}
          </div>
          <div class="msg msg--success" v-if="successMsg">
            <i class="ft-check-circle"></i> {{ successMsg }}
          </div>

          <div class="card-footer-pad">
            <button type="submit" class="submit-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              Save Profile
            </button>
          </div>
        </form>
      </div>

      <!-- ── Update Password ── -->
      <div class="form-card">
        <div class="form-card-header">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          Change Password
        </div>

        <form id="password-form" v-on:submit.prevent="updatePassword">
          <div class="fields-wrap">

            <div class="field-group">
              <label class="field-label">Current Password</label>
              <div class="input-wrap">
                <i class="ft-lock input-icon"></i>
                <input type="password" class="field-input" v-model="password" placeholder="Current password" required />
              </div>
            </div>

            <div class="field-group">
              <label class="field-label">New Password</label>
              <div class="input-wrap">
                <i class="ft-lock input-icon"></i>
                <input type="password" class="field-input" v-model="new_password" placeholder="New password" required />
              </div>
            </div>

            <div class="field-group">
              <label class="field-label">Confirm New Password</label>
              <div class="input-wrap">
                <i class="ft-lock input-icon"></i>
                <input type="password" class="field-input" v-model="confirm_new_password" placeholder="Confirm new password" required />
              </div>
            </div>

          </div>

          <!-- Messages -->
          <div class="msg msg--error" v-if="errorMsg2">
            <i class="ft-alert-circle"></i> {{ errorMsg2 }}
          </div>
          <div class="msg msg--success" v-if="successMsg2">
            <i class="ft-check-circle"></i> {{ successMsg2 }}
          </div>

          <div class="card-footer-pad">
            <button type="submit" class="submit-btn submit-btn--secondary">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              Update Password
            </button>
          </div>
        </form>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'profile',
  data: function () {
    return {
      pic: '',
      first_name: '',
      last_name: '',
      email: '',
      cellphone: '',
      password: '',
      new_password: '',
      confirm_new_password: '',
      errorMsg: '',
      errorMsg2: '',
      successMsg: '',
      successMsg2: ''
    }
  },
  mounted: function () {
    this.$store.commit('SET_LAYOUT', 'AppLayout')

    var user = JSON.parse(localStorage.getItem('user'))

    this.pic = user.parent.pic ? user.parent.pic : 'images/portrait/default-user-profile.svg'
    this.first_name = user.parent.first_name
    this.last_name = user.parent.last_name
    this.email = user.email
    this.cellphone = user.parent.cellphone
  },
  methods: {
    updatePic: function () {
      var that = this

      $.showLoading()
      var file = this.$refs.file.files[0]
      var metadata = { 'contentType': file.type }
      // eslint-disable-next-line
      var storageRef = firebase.storage().ref()

      storageRef.child('images/' + file.name).put(file, metadata).then(function (snapshot) {
        snapshot.ref.getDownloadURL().then(function (url) {
          that.pic = url
          $.hideLoading()
        })
      }).catch(function (error) {
        $.hideLoading()
        console.error('Upload failed:', error)
        alert(error)
      })
    },
    updateProfile: function () {
      $.showLoading()
      var that = this
      this.errorMsg = ''
      this.successMsg = ''

      var data = {
        token: localStorage.getItem('token'),
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        cellphone: this.cellphone,
        pic: this.pic
      }

      $.ajax({
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        },
        url: this.$config.apiUrl + 'basic/parent_profile_update',
        type: 'post',
        data: JSON.stringify(data),
        success: function (data) {
          $.hideLoading()

          if (data.success === false) {
            that.errorMsg = data.message
          } else {
            that.successMsg = 'Profile successfully updated'

            var user = JSON.parse(window.localStorage.getItem('user'))
            user.pic = that.pic
            user.email = that.email
            user.name = that.first_name + ' ' + that.last_name
            user.parent.first_name = that.first_name
            user.parent.last_name = that.last_name
            user.parent.cellphone = that.cellphone
            localStorage.setItem('user', JSON.stringify(user))
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          $.hideLoading()

          if (!navigator.onLine) {
            that.errorMsg = 'You are currently offline. Your profile will be updated when you reconnect.'

            var queue = window.localStorage.getItem('queue') ? JSON.parse(window.localStorage.getItem('queue')) : []
            queue.push({ url: this.url, data: data, method: 'post' })
            window.localStorage.setItem('queue', JSON.stringify(queue))
          }

          if (errorThrown === 'Unauthorized') {
            that.$router.push('/login')
          }
        }
      })
    },
    updatePassword: function () {
      this.errorMsg2 = ''
      this.successMsg2 = ''

      var that = this
      var user = JSON.parse(window.localStorage.getItem('user'))

      if (this.new_password !== this.confirm_new_password) {
        this.errorMsg2 = 'Confirmed password does not match the new password'
        return
      }

      var data = {
        username: user.username,
        password: this.password,
        new_password: this.new_password
      }

      $.ajax({
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        },
        url: this.$config.apiUrl + 'basic/update_password',
        type: 'post',
        data: JSON.stringify(data),
        success: function (data) {
          if (data.success === false) {
            that.errorMsg2 = data.message
          } else {
            that.successMsg2 = 'Password successfully changed'
            that.password = ''
            that.new_password = ''
            that.confirm_new_password = ''
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          $.hideLoading()
          if (errorThrown === 'Unauthorized') {
            that.$router.push('/login')
          }
          that.errorMsg2 = 'Something went wrong, please try again later'
        }
      })
    }
  }
}
</script>

<style scoped>
.profile-page {
  min-height: 100vh;
  background: #f0f4f8;
  padding-bottom: 40px;
}

/* ── Page header ── */
.page-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 30px 20px 20px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  position: fixed;
  top: 0; left: 0;
  width: 100%;
  z-index: 10;
  margin-top: 3.2rem;
  box-shadow: 0 8px 32px rgba(15, 61, 92, 0.35);
}

.back-btn {
  width: 36px; height: 36px;
  border-radius: 10px;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.2);
  color: #fff;
  display: flex; align-items: center; justify-content: center;
  font-size: 1rem; cursor: pointer; flex-shrink: 0;
  transition: background 0.15s;
}
.back-btn:hover { background: rgba(255,255,255,0.25); }

.header-info { display: flex; flex-direction: column; gap: 3px; }
.page-title  { font-size: 1.05rem; font-weight: 700; color: #fff; }
.page-subtitle { font-size: 0.73rem; color: rgba(255,255,255,0.65); font-weight: 500; }

/* ── Avatar hero ── */
.avatar-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 120px 20px 28px;
  background: linear-gradient(180deg, #0f3d5c 0%, #f0f4f8 100%);
}

.avatar-wrap {
  position: relative;
  width: 90px; height: 90px;
  border-radius: 50%;
  cursor: pointer;
  flex-shrink: 0;
}

.avatar-img {
  width: 90px; height: 90px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #fff;
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
  display: block;
}

.avatar-overlay {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: rgba(15, 61, 92, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  opacity: 0;
  transition: opacity 0.2s;
}
.avatar-wrap:hover .avatar-overlay { opacity: 1; }

.file-input { display: none; }

.avatar-name {
  font-size: 1.1rem;
  font-weight: 700;
  color: #fff;
  margin: 0;
  text-shadow: 0 1px 4px rgba(0,0,0,0.3);
}

.avatar-email {
  font-size: 0.8rem;
  color: rgba(255,255,255,0.75);
  margin: 0;
}

/* ── Section ── */
.section-pad {
  padding: 0 16px;
  max-width: 560px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Form cards ── */
.form-card {
  background: #fff;
  border-radius: 16px;
  border: 1.5px solid #e8edf2;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  overflow: hidden;
}

.form-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e8edf2;
  font-size: 0.78rem;
  font-weight: 700;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.9px;
}
.form-card-header svg { color: #1a587b; flex-shrink: 0; }

/* ── Fields ── */
.fields-wrap {
  padding: 18px 20px 4px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.field-group { display: flex; flex-direction: column; gap: 5px; }

.field-label {
  font-size: 0.73rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.7px;
}

.input-wrap { position: relative; display: flex; align-items: center; }

.input-icon {
  position: absolute;
  left: 13px;
  color: #94a3b8;
  font-size: 0.85rem;
  pointer-events: none;
}

.field-input {
  width: 100%;
  padding: 11px 14px 11px 38px;
  border: 1.5px solid #e8edf2;
  border-radius: 10px;
  font-size: 0.9rem;
  color: #0f172a;
  background: #f8fafc;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.15s;
  box-sizing: border-box;
}
.field-input:focus {
  outline: none;
  border-color: #1a587b;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(26,88,123,0.1);
}
.field-input::placeholder { color: #cbd5e1; }

/* ── Messages ── */
.msg {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 12px 20px 0;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 0.85rem;
  font-weight: 500;
  line-height: 1.5;
}
.msg--error   { background: #fef2f2; color: #dc2626; border: 1px solid #fecaca; }
.msg--success { background: #f0fdf4; color: #16a34a; border: 1px solid #bbf7d0; }

/* ── Card footer ── */
.card-footer-pad { padding: 16px 20px 20px; }

.submit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 13px;
  border-radius: 12px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  border: none;
  color: #fff;
  font-size: 0.92rem;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.1s;
  letter-spacing: 0.2px;
}
.submit-btn:hover  { opacity: 0.92; }
.submit-btn:active { transform: scale(0.98); }

.submit-btn--secondary {
  background: linear-gradient(135deg, #334155 0%, #1e293b 100%);
}
</style>
